export const PHD = "Ph.D";
export const DSC = "D.Sc/D.Litt";
export const PDF = "PDF";